import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uchz249maq: FaireBrandEntity = {
  token: "b_uchz249maq",
  type: "brand",
  name: "Willie J’s: The Easy PJ’s",
  avatarUrl:
    "https://cdn.faire.com/fastly/289dc92e031f71afdf68aa4ac27e8f033cf15ea975907673d0f31462969a4b30.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/679f6fcd3ad8cf51d0ebe18bddeb3ade112fb34cb4f0559737255384cff5f10d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/289dc92e031f71afdf68aa4ac27e8f033cf15ea975907673d0f31462969a4b30.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/679f6fcd3ad8cf51d0ebe18bddeb3ade112fb34cb4f0559737255384cff5f10d.png",
  location: "Duluth, GA, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Welcome to Willie J's! Our bamboo pajamas are expertly crafted to provide comfort for all of life's moments. Whether it's a big celebration, a time for extra love and support, or simply a relaxing night in, our pajamas are designed for easy comfort. Our durable and eco-friendly materials make them the perfect choice when quality matters such as for gifts,  getting ready outfits for bridal parties, maternity wear, and the go-to nightgown for women going through menopause. We also offer adaptive versions of all our button pajama tops where we replace the buttons with Velcro®. In addition, we offer adaptive pajamas for men in 100% cotton flannel or a cotton/poly blend. Soon we will also offer men's bamboo pajama short sets. Thank you for considering Willie J's for your cozy and long-lasting pajama needs!\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:33.734Z",
    importedBy: "entity-db-cli",
  },
};
